module.exports = __webpack_public_path__ + "media/images/linkedin-acaaf7762ca8926084a66f23248377e9.svg";